import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startLogout } from '../../../actions/auth';
import Dropdown from 'react-bootstrap/Dropdown';
import { Icon } from '../../utils/UtilsComponent';
import {
	columnStyle,
	getFullName,
	whichURLAdmin,
} from '../../../helpers/utils';
import { useNavigate } from 'react-router-dom';

const MenuItem = ({ title, icon, action = null }) => (
	<Dropdown.Item onClick={action}>
		<Icon name={icon} /> {title}
	</Dropdown.Item>
);

const defaultImgProfile =
	'https://www.inspirations.boutique/wp-content/uploads/2019/10/blank-person-profile.png';

export const UserMenu = () => {
	// Current version
	const currentVersion =
		localStorage.getItem('currentVersionPilu') || 'En mantenimiento';
	// Dispatch
	const dispatch = useDispatch();
	// Handle logout
	const handleLogout = () => dispatch(startLogout());
	// User
	const { user } = useSelector((state) => state);
	// Navigation
	const navigate = useNavigate();
	// Area
	const [area, setArea] = useState(null);
	const [role, setRole] = useState(null);

	// Handle go to admin site
	const handleAdmin = () => window.open(whichURLAdmin());
	// Handle go to new ticket
	const handleTicket = () => {
		const path = '/dashboard/nuevo-ticket';
		localStorage.setItem('lastPathPilu', path);
		navigate(path);
	};

	useEffect(() => {
		if (user?.user_type?.id === 4) {
			setArea(user?.area?.name);
		} else {
			setRole(user?.user_type?.name);
		}
	}, []);

	return (
		<Dropdown className='d-inline mx-2'>
			<Dropdown.Toggle
				id='dropdown-autoclose-true'
				variant='light'
				style={{ width: '100%' }}
			>
				<div className='d-flex align-items-center link-dark text-decoration-none '>
					{/* Just use the name and the first lastname  */}
					{user && (
						<>
							<img
								src={
									user?.img_profile?.length > 0
										? user?.img_profile
										: defaultImgProfile
								}
								alt='test'
								width='32'
								height='32'
								className='rounded-circle me-2'
							/>
							<div
								style={{
									...columnStyle,
									margin: '0 0 -15px 10px',
									width: '100%',
									textAlign: 'start',
									overflow: 'hidden',
								}}
							>
								<p>
									<strong>
										{getFullName(user).split(' ')[0]}{' '}
										{getFullName(user).split(' ')[1]}
									</strong>
									<br />
									<small>
										{user?.user_type?.id === 4
											? area
											: role}
									</small>
									<br />
									<small>{currentVersion} 🚀</small>
								</p>
							</div>
						</>
					)}
				</div>
			</Dropdown.Toggle>

			<Dropdown.Menu>
				{/* Admin */}
				<MenuItem
					title='Administración'
					icon='building'
					action={handleAdmin}
				/>
				{/* New ticket */}
				<MenuItem
					title='Reportar problema'
					icon='ticket'
					action={handleTicket}
				/>
				{/* Logout */}
				<MenuItem
					title='Salir'
					icon='box-arrow-left'
					action={handleLogout}
				/>
			</Dropdown.Menu>
		</Dropdown>
	);
};
